import EventEmitter from 'wolfy87-eventemitter';
import Events from './Events';

class Timer extends EventEmitter {
  constructor(to = 0) {
    super();
    this.setCurrentTime(0);
    this.setTo(to);
    this.interval = null;
  }

  getTo() {
    return this.to;
  }

  setTo(to) {
    this.to = to;
    this.emit(Events.TO_TIME_CHANGED, {to});
  }

  getCurrentTime() {
    return this.currentTime;
  }

  setCurrentTime(time = 0) {
    this.currentTime = time;
    this.emit(Events.CURRENT_TIME_CHANGED, {
      current: time,
    });
  }

  isToTimeReached() {
    return this.currentTime >= this.to;
  }

  tick() {
    let previous = this.getCurrentTime();
    let current = previous + 1;
    this.setCurrentTime(current);
    this.emit(Events.TICK, {
      previous,
      current,
      to: this.getTo(),
    });
  }

  start() {
    this.interval = setInterval(() => {
      this.tick();
      if (this.isToTimeReached()) {
        this.emit(Events.TO_TIME_REACHED, {to: this.getTo()});
        this.reset();
      }
    }, 1000);
    this.emit(Events.START, {
      current: this.getCurrentTime(),
      to: this.getTo(),
    });
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.emit(Events.STOP, {
      current: this.getCurrentTime(),
      to: this.getTo(),
    });
  }

  reset() {
    this.stop();
    this.setCurrentTime(0);
    this.emit(Events.RESET, {
      current: this.getCurrentTime(),
      to: this.getTo(),
    });
  }
}

export default Timer;


// WEBPACK FOOTER //
// ./src/modules/dro/timer/Timer.js